<!-- 项目文件 -->
<template>
    <div class="w100p bgf6">
        <Header></Header>
        <Titleimg :img="bgImg"></Titleimg>
        <div class="pt25 pl16 pr16 pb25 bgfff">
            <p class="fs16 c333 disinblock posre textc w100p flexc">
                <span class="border-bottom1">
                    智能化驾校培训
                </span>
            </p>
            <div class="mt25">
                <van-image lazy-load class="imgauto" :src="img" />
                <!-- <img class="imgauto" src="../../../public/img/img12.png" alt=""> -->
            </div>
            <div>
                <P class="mt16 alit">
                    <i> <img class="w14 h18" src="../../../public/img/img18.png" alt=""> </i>
                    <span class="cf399 fs16 disinblock pl8">学员APP：在线约课，练车时间自己做主。</span>
                </P>

                <P class="mt16 mt16 alit">
                    <i> <img class="w14 h18" src="../../../public/img/img19.png" alt=""> </i>
                    <span class="c1f8 fs16 disinblock pl8">校长APP：在线教学，教学计划一目了然。</span>
                </P>

                <P class="mt16 mt16 alit">
                    <i> <img class="w14 h18" src="../../../public/img/img20.png" alt=""> </i>
                    <span class="c62d fs16 disinblock pl8">教练APP：在线管理，统筹经营 ，掌控全局。</span>
                </P>
            </div>
        </div>

        <div class="mt16 bgfff pl16 pr16 pt10 pb24">
            <p class="fs16 c333 disinblock posre textc w100p flexc">
                <span class="border-bottom1">
                    智能化驾校培训
                </span>
            </p>
            <div class="pt10">
                <ul class="  w100p row1_txtc pb20">
                    <li class="borderradiusr disinblock minh130 w48p mt38 box pb12 pl16 pr16 ml2 mr2 bgfcf9 box-shadow22 posre">
                        <P class="fs0 posab top-22 left0 pl16"><img class="w44 h44" src="../../../public/img/img13.png" alt=""></P>
                        <p class="fs13 c333 fbold pt30">驾校管理</p>
                        <p class="fs13 c999 pt8">
                            为驾校提供学员、教练，个性化教学计划管理服务。
                        </p>
                    </li>
            
                    <li class="borderradiusr disinblock minh130 w48p mt38 box pb12 pl16 pr16 ml2 mr2 bgfcf9 box-shadow22 posre">
                        <P class="fs0 posab top-22 left0 pl16"><img class="w44 h44" src="../../../public/img/img14.png" alt=""></P>
                        <p class="fs13 c333 fbold pt30">流量服务</p>
                        <p class="fs13 c999 pt8">
                            为驾校提供招生流量线索。
                        </p>
                    </li>

                    <li class="borderradiusr disinblock minh130 w48p mt38 box pb12 pl16 pr16 ml2 mr2 bgfcf9 box-shadow22 posre">
                        <P class="fs0 posab top-22 left0 pl16"><img class="w44 h44" src="../../../public/img/img15.png" alt=""></P>
                        <p class="fs13 c333 fbold pt30">教学服务</p>
                        <p class="fs13 c999 pt8">
                            为教练提供完整的教学培训软件，线上线下无缝衔接。
                        </p>
                    </li>

                    <li class="borderradiusr disinblock minh130 w48p mt38 box pb12 pl16 pr16 ml2 mr2 bgfcf9 box-shadow22 posre">
                        <P class="fs0 posab top-22 left0 pl16"><img class="w44 h44" src="../../../public/img/img16.png" alt=""></P>
                        <p class="fs13 c333 fbold pt30">培训服务</p>
                        <p class="fs13 c999 pt8">
                            为学员提供方便快捷的学车培训驾考一站式服务。
                        </p>
                    </li>

                    <li class="borderradiusr disinblock minh130 w48p mt38 box pb12 pl16 pr16 ml2 mr2 bgfcf9 box-shadow22 posre">
                        <P class="fs0 posab top-22 left0 pl16"><img class="w44 h44" src="../../../public/img/img17.png" alt=""></P>
                        <p class="fs13 c333 fbold pt30">增值服务</p>
                        <p class="fs13 c999 pt8">
                            为驾校、学员提供招生、培训驾考各维度的实用、便捷服务。
                        </p>
                    </li>
                </ul>
            
            
            </div>
        </div>
        
        
        <Bannerswitch></Bannerswitch>
        <Gridswitch></Gridswitch>
        <Applyset></Applyset>
        <Footer></Footer>

    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import Titleimg from '@/components/Titleimg';
    import Gridswitch from '@/components/Gridswitch';
    import Bannerswitch from '@/components/Bannerswitch';
    import Applyset from '@/components/Applyset';
    import $ from "jquery";
    export default {
        data() {
            return {
                bgImg: require('../../../public/img/img6.png'),
                caseList: [],
                img: require('../../../public/img/img12.png'),


            };
        },
        components: {
            Header,
            Titleimg,
            Footer,
            Bannerswitch,
            Gridswitch,
            Applyset
        },
        methods: {

        },
        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>

</style>